// Actions pour Tasks - Système de tâches et arguments

import * as actionTypes from './actionTypes';

// Actions synchrones
export const setFunctions = (functions) => ({
  type: actionTypes.SET_FUNCTIONS,
  functions,
});

export const setFunctionsLoading = (isLoading) => ({
  type: actionTypes.SET_FUNCTIONS_LOADING,
  isLoading,
});

export const addFunction = (functionData) => ({
  type: actionTypes.ADD_FUNCTION,
  functionData,
});

export const updateFunction = (functionData) => ({
  type: actionTypes.UPDATE_FUNCTION,
  functionData,
});

export const deleteFunction = (functionId) => ({
  type: actionTypes.DELETE_FUNCTION,
  functionId,
});

// Actions asynchrones (à implémenter selon votre API)
export const reqObtenirFonctions = () => {
  return async (dispatch) => {
    dispatch(setFunctionsLoading(true));

    try {
      // TODO: Remplacer par votre appel API réel
      // const response = await apiCall.getFunctions();

      // Données mockées complètes pour tous les types d'arguments
      const mockFunctions = [
        {
          id: 'func_1',
          nom: 'Analyse sensors_list',
          description: 'Fonction complète démontrant le type sensors_list',
          type: 'system',
          arguments: [
            {
              id: 'arg_1',
              position: 0,
              nom: 'capteurs_temperature',
              type: 'sensors_list',
              obligatoire: true,
              description: 'Sélection de capteurs de température',
              valeurParDefaut: ['sensor_temp_01', 'sensor_temp_02'],
              options: {
                minCapteurs: 1,
                maxCapteurs: 10,
                permitMultiple: true,
                sensorsData: [
                  {
                    id: 'sensor_temp_01',
                    name: 'Capteur Température Bureau',
                    type: 'temperature',
                    location: 'Bureau A1',
                  },
                  {
                    id: 'sensor_temp_02',
                    name: 'Capteur Température Atelier',
                    type: 'temperature',
                    location: 'Atelier B2',
                  },
                  {
                    id: 'sensor_hum_01',
                    name: 'Capteur Humidité Hall',
                    type: 'humidity',
                    location: 'Hall C3',
                  },
                  {
                    id: 'sensor_press_01',
                    name: 'Capteur Pression Chaudière',
                    type: 'pressure',
                    location: 'Chaufferie D4',
                  },
                  {
                    id: 'sensor_light_01',
                    name: 'Capteur Luminosité Entrée',
                    type: 'light',
                    location: 'Entrée E5',
                  },
                ],
              },
            },
          ],
        },
        {
          id: 'func_2',
          nom: 'Gestion date_range',
          description:
            'Fonction démontrant le type date_range avec plages prédéfinies',
          type: 'custom',
          arguments: [
            {
              id: 'arg_2',
              position: 0,
              nom: 'periode_analyse',
              type: 'date_range',
              obligatoire: true,
              description: "Sélection d'une période d'analyse",
              valeurParDefaut: { debut: '2024-10-01', fin: '2024-10-31' },
              options: {
                formatDate: 'YYYY-MM-DD HH:mm',
                permettreHeures: true,
                plagesPredefiniees: [
                  { label: "Aujourd'hui", value: 'today' },
                  { label: 'Cette semaine', value: 'week' },
                  { label: 'Ce mois', value: 'month' },
                  { label: 'Dernier trimestre', value: 'quarter' },
                ],
              },
            },
          ],
        },
        {
          id: 'func_3',
          nom: 'Configuration frequency',
          description: 'Fonction utilisant le type frequency pour intervalles',
          type: 'system',
          arguments: [
            {
              id: 'arg_3',
              position: 0,
              nom: 'intervalle_mesure',
              type: 'frequency',
              obligatoire: true,
              description: 'Fréquence de prise de mesures',
              valeurParDefaut: { valeur: 15, unite: 'minutes' },
              options: {
                unites: ['secondes', 'minutes', 'heures', 'jours', 'semaines'],
                uniteParDefaut: 'minutes',
                min: 1,
                max: 1440,
                presets: [
                  { label: 'Temps réel', valeur: 1, unite: 'secondes' },
                  { label: 'Chaque minute', valeur: 1, unite: 'minutes' },
                  { label: 'Toutes les 5 min', valeur: 5, unite: 'minutes' },
                  { label: 'Horaire', valeur: 1, unite: 'heures' },
                  { label: 'Quotidien', valeur: 1, unite: 'jours' },
                ],
              },
            },
          ],
        },
        {
          id: 'func_4',
          nom: 'Paramètres number',
          description:
            'Fonction avec différents types de paramètres numériques',
          type: 'custom',
          arguments: [
            {
              id: 'arg_4a',
              position: 0,
              nom: 'seuil_temperature',
              type: 'number',
              obligatoire: true,
              description: 'Seuil de température critique',
              valeurParDefaut: 75.5,
              options: {
                min: -50,
                max: 150,
                step: 0.1,
                unite: '°C',
                slider: true,
              },
            },
            {
              id: 'arg_4b',
              position: 1,
              nom: 'pourcentage_alerte',
              type: 'number',
              obligatoire: false,
              description: 'Pourcentage pour déclencher une alerte',
              valeurParDefaut: 85,
              options: {
                min: 0,
                max: 100,
                step: 1,
                unite: '%',
                slider: true,
              },
            },
          ],
        },
        {
          id: 'func_5',
          nom: 'Saisie text avancée',
          description: 'Fonction démontrant les capacités du type text',
          type: 'system',
          arguments: [
            {
              id: 'arg_5a',
              position: 0,
              nom: 'nom_rapport',
              type: 'text',
              obligatoire: true,
              description: 'Nom du rapport à générer',
              valeurParDefaut: 'Rapport mensuel octobre 2024',
              options: {
                maxLength: 100,
                minLength: 5,
                placeholder: 'Entrez le nom du rapport (5-100 caractères)...',
                regex: '^[a-zA-Z0-9\\s\\-_]+$',
                regexMessage:
                  'Seuls les lettres, chiffres, espaces, tirets et underscores sont autorisés',
              },
            },
            {
              id: 'arg_5b',
              position: 1,
              nom: 'description_longue',
              type: 'text',
              obligatoire: false,
              description: 'Description détaillée (optionnelle)',
              valeurParDefaut: '',
              options: {
                maxLength: 500,
                multiline: true,
                placeholder: 'Description détaillée du rapport...',
                rows: 4,
              },
            },
          ],
        },
        {
          id: 'func_6',
          nom: 'Options boolean',
          description: 'Fonction avec différentes options booléennes',
          type: 'custom',
          arguments: [
            {
              id: 'arg_6a',
              position: 0,
              nom: 'activer_notifications',
              type: 'boolean',
              obligatoire: false,
              description: 'Activer les notifications par email',
              valeurParDefaut: true,
              options: {
                labelOn: 'Activé',
                labelOff: 'Désactivé',
                style: 'switch',
              },
            },
            {
              id: 'arg_6b',
              position: 1,
              nom: 'mode_debug',
              type: 'boolean',
              obligatoire: false,
              description: 'Activer le mode debug pour logs détaillés',
              valeurParDefaut: false,
              options: {
                labelOn: 'Debug ON',
                labelOff: 'Debug OFF',
                style: 'checkbox',
              },
            },
            {
              id: 'arg_6c',
              position: 2,
              nom: 'sauvegarde_auto',
              type: 'boolean',
              obligatoire: false,
              description: 'Sauvegarde automatique des résultats',
              valeurParDefaut: true,
              options: {
                labelOn: 'Auto-save',
                labelOff: 'Manuel',
                style: 'toggle',
              },
            },
          ],
        },
        {
          id: 'func_7',
          nom: 'Sélection select',
          description: 'Fonction avec sélections simples variées',
          type: 'system',
          arguments: [
            {
              id: 'arg_7a',
              position: 0,
              nom: 'format_export',
              type: 'select',
              obligatoire: true,
              description: 'Format de fichier pour export',
              valeurParDefaut: 'xlsx',
              options: {
                optionsList: [
                  {
                    value: 'csv',
                    label: 'CSV - Comma Separated Values',
                    icon: '📄',
                  },
                  {
                    value: 'xlsx',
                    label: 'Excel - Feuille de calcul',
                    icon: '📊',
                  },
                  {
                    value: 'json',
                    label: 'JSON - JavaScript Object',
                    icon: '🔧',
                  },
                  {
                    value: 'pdf',
                    label: 'PDF - Portable Document',
                    icon: '📋',
                  },
                  {
                    value: 'xml',
                    label: 'XML - Extensible Markup',
                    icon: '📝',
                  },
                ],
                searchable: true,
              },
            },
            {
              id: 'arg_7b',
              position: 1,
              nom: 'niveau_log',
              type: 'select',
              obligatoire: true,
              description: 'Niveau de logging système',
              valeurParDefaut: 'info',
              options: {
                optionsList: [
                  {
                    value: 'debug',
                    label: 'Debug - Très détaillé',
                    color: '#6c757d',
                  },
                  {
                    value: 'info',
                    label: 'Info - Informations générales',
                    color: '#17a2b8',
                  },
                  {
                    value: 'warning',
                    label: 'Warning - Avertissements',
                    color: '#ffc107',
                  },
                  {
                    value: 'error',
                    label: 'Error - Erreurs seulement',
                    color: '#dc3545',
                  },
                  {
                    value: 'critical',
                    label: 'Critical - Critique uniquement',
                    color: '#6f42c1',
                  },
                ],
              },
            },
          ],
        },
        {
          id: 'func_8',
          nom: 'Multi-sélection avancée',
          description: 'Fonction utilisant multi_select avec options complexes',
          type: 'custom',
          arguments: [
            {
              id: 'arg_8a',
              position: 0,
              nom: 'types_capteurs',
              type: 'multi_select',
              obligatoire: true,
              description: "Types de capteurs à inclure dans l'analyse",
              valeurParDefaut: ['temperature', 'humidity'],
              options: {
                optionsList: [
                  {
                    value: 'temperature',
                    label: 'Capteurs de température',
                    icon: '🌡️',
                    category: 'Climat',
                  },
                  {
                    value: 'humidity',
                    label: "Capteurs d'humidité",
                    icon: '💧',
                    category: 'Climat',
                  },
                  {
                    value: 'pressure',
                    label: 'Capteurs de pression',
                    icon: '📊',
                    category: 'Mécanique',
                  },
                  {
                    value: 'vibration',
                    label: 'Capteurs de vibration',
                    icon: '📳',
                    category: 'Mécanique',
                  },
                  {
                    value: 'light',
                    label: 'Capteurs de luminosité',
                    icon: '💡',
                    category: 'Environnement',
                  },
                  {
                    value: 'sound',
                    label: 'Capteurs sonores',
                    icon: '🔊',
                    category: 'Environnement',
                  },
                  {
                    value: 'motion',
                    label: 'Détecteurs de mouvement',
                    icon: '🏃',
                    category: 'Sécurité',
                  },
                  {
                    value: 'smoke',
                    label: 'Détecteurs de fumée',
                    icon: '🚨',
                    category: 'Sécurité',
                  },
                ],
                permitMultiple: true,
                maxSelections: 5,
                groupByCategory: true,
                searchable: true,
              },
            },
            {
              id: 'arg_8b',
              position: 1,
              nom: 'notifications_canaux',
              type: 'multi_select',
              obligatoire: false,
              description: 'Canaux de notification à utiliser',
              valeurParDefaut: ['email'],
              options: {
                optionsList: [
                  { value: 'email', label: 'Email', icon: '📧', enabled: true },
                  { value: 'sms', label: 'SMS', icon: '📱', enabled: true },
                  {
                    value: 'webhook',
                    label: 'Webhook',
                    icon: '🔗',
                    enabled: true,
                  },
                  {
                    value: 'slack',
                    label: 'Slack',
                    icon: '💬',
                    enabled: false,
                    tooltip: 'Configuration requise',
                  },
                  {
                    value: 'teams',
                    label: 'Microsoft Teams',
                    icon: '🏢',
                    enabled: false,
                    tooltip: 'Configuration requise',
                  },
                ],
                permitMultiple: true,
                selectAll: true,
              },
            },
          ],
        },
        {
          id: 'func_9',
          nom: 'Upload file complet',
          description: 'Fonction gérant différents types de fichiers',
          type: 'system',
          arguments: [
            {
              id: 'arg_9a',
              position: 0,
              nom: 'fichier_configuration',
              type: 'file',
              obligatoire: true,
              description: 'Fichier de configuration principal',
              valeurParDefaut: null,
              options: {
                acceptedTypes: ['.json', '.yaml', '.yml', '.xml'],
                maxSize: '5MB',
                multiple: false,
                preview: true,
                validateContent: true,
              },
            },
            {
              id: 'arg_9b',
              position: 1,
              nom: 'fichiers_donnees',
              type: 'file',
              obligatoire: false,
              description: 'Fichiers de données supplémentaires (optionnels)',
              valeurParDefaut: null,
              options: {
                acceptedTypes: ['.csv', '.xlsx', '.xls', '.json', '.txt'],
                maxSize: '50MB',
                multiple: true,
                maxFiles: 10,
                preview: false,
                dragDrop: true,
              },
            },
            {
              id: 'arg_9c',
              position: 2,
              nom: 'template_rapport',
              type: 'file',
              obligatoire: false,
              description: 'Template pour la génération de rapport',
              valeurParDefaut: null,
              options: {
                acceptedTypes: ['.docx', '.pdf', '.html', '.rtf'],
                maxSize: '20MB',
                multiple: false,
                preview: true,
                replaceExisting: true,
              },
            },
          ],
        },
        {
          id: 'func_10',
          nom: 'Configuration JSON avancée',
          description: 'Fonction utilisant JSON avec validation et templates',
          type: 'custom',
          arguments: [
            {
              id: 'arg_10a',
              position: 0,
              nom: 'config_principale',
              type: 'json',
              obligatoire: true,
              description: 'Configuration principale du système',
              valeurParDefaut: JSON.stringify(
                {
                  version: '1.0',
                  database: {
                    host: 'localhost',
                    port: 5432,
                    name: 'argos_db',
                  },
                  features: {
                    realtime: true,
                    notifications: true,
                    backup: {
                      enabled: true,
                      frequency: 'daily',
                    },
                  },
                },
                null,
                2
              ),
              options: {
                validateJson: true,
                formatJson: true,
                schema: {
                  type: 'object',
                  required: ['version', 'database'],
                  properties: {
                    version: { type: 'string' },
                    database: {
                      type: 'object',
                      required: ['host', 'port', 'name'],
                      properties: {
                        host: { type: 'string' },
                        port: { type: 'number' },
                        name: { type: 'string' },
                      },
                    },
                  },
                },
                templates: [
                  {
                    name: 'Configuration minimale',
                    content: {
                      version: '1.0',
                      database: { host: 'localhost', port: 5432, name: 'db' },
                    },
                  },
                  {
                    name: 'Configuration complète',
                    content: {
                      version: '1.0',
                      database: {
                        host: 'localhost',
                        port: 5432,
                        name: 'argos_db',
                      },
                      features: { realtime: true, notifications: true },
                      security: { ssl: true, authentication: 'oauth2' },
                    },
                  },
                ],
              },
            },
            {
              id: 'arg_10b',
              position: 1,
              nom: 'parametres_avances',
              type: 'json',
              obligatoire: false,
              description: 'Paramètres avancés optionnels',
              valeurParDefaut: JSON.stringify(
                {
                  cache: { ttl: 3600, maxSize: '100MB' },
                  logging: { level: 'info', format: 'json' },
                },
                null,
                2
              ),
              options: {
                validateJson: true,
                formatJson: true,
                collapsible: true,
                height: 200,
              },
            },
          ],
        },
      ];

      dispatch(setFunctions(mockFunctions));
    } catch (error) {
      console.error('Erreur lors du chargement des fonctions:', error);
      // Gestion d'erreur
    } finally {
      dispatch(setFunctionsLoading(false));
    }
  };
};

export const reqCreerFunction = (functionData) => {
  return async (dispatch) => {
    try {
      // TODO: Remplacer par votre appel API réel
      // const response = await apiCall.createFunction(functionData);

      dispatch(addFunction(functionData));

      return { success: true };
    } catch (error) {
      console.error('Erreur lors de la création de la fonction:', error);
      return { success: false, error };
    }
  };
};

export const reqModifierFunction = (functionData) => {
  return async (dispatch) => {
    try {
      // TODO: Remplacer par votre appel API réel
      // const response = await apiCall.updateFunction(functionData);

      dispatch(updateFunction(functionData));

      return { success: true };
    } catch (error) {
      console.error('Erreur lors de la modification de la fonction:', error);
      return { success: false, error };
    }
  };
};

export const reqSupprimerFunction = (functionId) => {
  return async (dispatch) => {
    try {
      // TODO: Remplacer par votre appel API réel
      // const response = await apiCall.deleteFunction(functionId);

      dispatch(deleteFunction(functionId));

      return { success: true };
    } catch (error) {
      console.error('Erreur lors de la suppression de la fonction:', error);
      return { success: false, error };
    }
  };
};
